import { Container, Row, Col } from 'react-bootstrap';
//&copy;
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <Container>
        <Row>
          <Col className='text-center py-3'>
            {1 === 1 ? (<p>Consultant Work-Lists  {currentYear}</p>) :
              (<p>ProShop &copy; {currentYear}</p>)


            }
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
